import { useEffect, useState } from 'react'
import { isFretoHabilitado } from './lotesRepository'

export const useIsFretoHabilitado = () => {
  const [habilitado, setHabilitado] = useState(false)

  const fetch = async () => {
    isFretoHabilitado().then(response => {
      if (response.ok) {
        setHabilitado(response.data?.result ?? false)
      } else {
        setHabilitado(false)
      }
    })
  }

  useEffect(() => {
    fetch()

    return () => {
      setHabilitado(false)
    }
  }, [])

  return { isFretoHabilitado: habilitado, reload: fetch }
}
